import { useSelector } from 'react-redux';
import Address from './Address';
import Menu from './Menu';

const Header = (props) => {
	const { progress } = props;
  const colors = useSelector((store) => store?.color)
	return (
		<header
			className='fixed top-0 z-[1] w-full max-w-md h-17'
			style={{
				transition: 'background-color .5s linear',
				background: progress > 0.95 ? colors?.roseViolet : 'transparent',
			}}>
			<div className='flex items-center justify-between gap-3 px-4 h-12 mt-5'>
				<div className='flex items-center flex-1 min-w-0 gap-2'>
					<Address />
				</div>
				<Menu />
			</div>
		</header>
	);
};

export default Header;
